import { render } from "./IstcMobile.vue?vue&type=template&id=519a845e"
import script from "./IstcMobile.vue?vue&type=script&lang=js"
export * from "./IstcMobile.vue?vue&type=script&lang=js"

import "./IstcMobile.vue?vue&type=style&index=0&id=519a845e&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__